import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.mv',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Langkawi escape early and enjoy the added luxury of a complimentary round-trip ferry transfer from Kuala Kedah to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-9953">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-9954">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-9955">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-9956" />
          <span data-id="element-9957">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-9958">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-9959">
          <div className="flex justify-between items-center" data-id="element-9960">
            <h2 className="text-xl font-bold" data-id="element-9961">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-9962">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-9963">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-9964">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-9965">
          <div className="p-6 border-r border-gray-200" data-id="element-9966">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9967">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9968">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9969">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-9970">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9971">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9972">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9973">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9974">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9975">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9976">
            <div data-id="element-9977">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9978">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9979">{reservation.booking.id}</p>
            </div>
            <div data-id="element-9980">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9981">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9982">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9983">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9984">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9985">
            <div data-id="element-9986">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9987">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9988">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-9989">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9990">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9991">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9992">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9993">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9994">
            <div data-id="element-9995">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9996">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9997">{reservation.room.name}</p>
            </div>
            <div data-id="element-9998">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9999">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10000">{reservation.room.view}</p>
            </div>
            <div data-id="element-10001">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10002">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10003">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10004">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10005">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-10006">
            <h4 className="text-base font-medium mb-4" data-id="element-10007">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10008">
              <div data-id="element-10009">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10010">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10011">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-10012">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10013">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10014">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-10015">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10016">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10017">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-10018">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10019">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10020">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-10021">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10022">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10023">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-10024">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10025">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10026">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-10027">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10028">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-10029">
            <div data-id="element-10030">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10031">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10032">{reservation.rate.name}</p>
            </div>
            <div data-id="element-10033">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10034">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10035">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-10036">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10037">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-10038">
            <div className="flex justify-between" data-id="element-10039">
              <p className="text-sm text-gray-500" data-id="element-10040">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10041">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-10042">
              <p className="text-sm text-gray-500" data-id="element-10043">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10044">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-10045">
              <p className="text-sm font-medium" data-id="element-10046">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-10047">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}